import { render } from "./ReferentialCategoriesView.vue?vue&type=template&id=784689ff&ts=true"
import script from "./ReferentialCategoriesView.ts?vue&type=script&lang=ts"
export * from "./ReferentialCategoriesView.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__